import ColorStyles from '@components/ColorStyles';
import BrSplitDropdownMenu from './BrSplitDropdownMenu';

BrSplitDropdownMenu.ColorStyles = ColorStyles;
export default BrSplitDropdownMenu;
